export default __webpack_public_path__ + "static/media/twitter-default.6373abc3.svg";